import type { StructuredCollectionConfig } from '@ltvco/refresh-lib/hooks';

/**
 * Collections used by the Social Security Records.
 *
 * IMPORTANT:
 * - The order of this list must match the order defined in Remoulade.
 * - Do not reorder existing collections, as the position is used to maintain
 *   consistency with Remoulade mappings and processing logic.
 * - When adding a new collection, append it to the end of the array.
 * - Existing entries should remain in their current positions.
 */
export const SOCIAL_SECURITY_INDEX_COLLECTIONS: StructuredCollectionConfig[] = [
  {
    id: '0000125',
    plainName: 'United States, Social Security Claims, 1937-1978',
    type: 'social_security_index',
    source: 'socialSecurityRecordsSearch',
    reportType: 'social_security_indexes',
    ga4ReportType: 'us_social_security_claims',
    yearStart: 1937,
    yearEnd: 1978,
    events: [
      {
        name: 'Life Claim',
        isRange: false,
        display: 'Social Security Claim',
      },
    ],
    overrides: [
      {
        source: 'events',
        target: 'event_primary_date_full',
        modifiers: [
          { name: 'findEvent', args: { event: 'Life Claim' } },
          { name: 'eventToDateRange' },
        ],
      },
    ],
    isV2: true,
  },
  {
    id: '0000006',
    plainName: 'United States, Social Security Applications, 1935-2014',
    type: 'social_security_index',
    source: 'socialSecurityRecordsSearch',
    reportType: 'social_security_indexes',
    ga4ReportType: 'us_social_security_applications',
    yearStart: 1935,
    yearEnd: 2014,
    events: [
      {
        name: 'Life Claim',
        isRange: false,
        display: 'Social Security Application',
      },
    ],
    overrides: [
      {
        source: 'events',
        target: 'event_primary_date_full',
        modifiers: [
          { name: 'findEvent', args: { event: 'Life Claim' } },
          { name: 'eventToDateRange' },
        ],
      },
    ],
    isV2: true,
  },
];
